import {ThemeVariableType} from '@toolify/client/src/modules/theme/enum/ThemeVariableType'
import {IThemeVariables} from '@toolify/client/src/modules/theme/types/IThemeVariables'
import {
  LightModernPaletteVariantType,
} from '@toolify/server/src/services/UserSettingsService/strategies/LightModernPaletteVariantUserSettingStrategy/enum/LightModernPaletteVariantType'
import {
  FiordNightThemeVariables,
} from '@toolify/client/src/modules/theme/strategies/fiord-night/FiordNightThemeVariables'

// Szarosci palety (Dark grey, Grey, Light grey - trzy ostatnie) w Graficie neutralne: niebieskawe szarosci Fiord pasuja
// do Lawendy, a na neutralnych powierzchniach Grafitu plakietka "Grey" wygladala na jasnoniebieska. Jasnosc taka
// sama jak w Fiord, wiec kontrast surowego koloru do bieli zostaje (7,99 / 4,50 / 2,90). Kolor opcji jest zapisany
// jako indeks palety, wiec dane sie nie zmieniaja
const GraphitePaletteColors: string[] = [
  ...FiordNightThemeVariables[ThemeVariableType.PaletteColors].slice(0, -3),
  '#4e5154',
  '#74777b',
  '#95989c',
]

export const LightModernVariantOverridesMap = new Map<LightModernPaletteVariantType, Partial<IThemeVariables>>([
  [LightModernPaletteVariantType.Graphite, {
    [ThemeVariableType.SurfaceDimColor]: '#f7f7f8',
    [ThemeVariableType.SurfaceColor]: '#fafafb',
    // = --database-table-grid-color Grafitu: linie tabeli, obrys karty grupy, siatka i obrys dymka wykresow jak w Lawendzie
    [ThemeVariableType.DatabaseTableGridColor]: '#e6e7ea',
    [ThemeVariableType.ContainerHighestColor]: '#d3d4da',
    [ThemeVariableType.ContainerHighColor]: '#e0e1e5',
    [ThemeVariableType.ContainerColor]: '#f4f4f6',
    [ThemeVariableType.ContainerLowColor]: '#ffffff',
    [ThemeVariableType.ContainerLowestColor]: '#f1f1f3',
    [ThemeVariableType.ContentBrightColor]: '#1e2125',
    [ThemeVariableType.ContentLightColor]: '#292d32',
    [ThemeVariableType.ContentNormalColor]: '#2f3338',
    [ThemeVariableType.ContentDimColor]: '#65686d',
    [ThemeVariableType.ContentDarkColor]: '#94979c',
    [ThemeVariableType.ContentDarkestColor]: '#c2c4c8',
    [ThemeVariableType.PrimaryColor]: '#3e63dd',
    [ThemeVariableType.PrimaryHoverColor]: '#3458c8',
    [ThemeVariableType.PrimaryContainerColor]: '#e9edfc',
    [ThemeVariableType.PrimaryContainerHoverColor]: '#dae2fa',
    [ThemeVariableType.OnPrimaryContainerColor]: '#243d8f',
    [ThemeVariableType.SecondaryColor]: '#65686d',
    [ThemeVariableType.SecondaryContainerColor]: '#e5e5e9',
    [ThemeVariableType.OnSecondaryContainerColor]: '#2f3338',
    [ThemeVariableType.DatabaseTableHeaderHoverBackgroundColor]: '#f4f4f6',
    [ThemeVariableType.DatabaseCellHoverBackgroundColor]: '#f4f4f6',
    [ThemeVariableType.DatabaseTableStickyShadowColor]: 'rgba(32, 34, 38, 0.04)',
    [ThemeVariableType.DatabaseTableScrollShadowColor]: 'rgba(32, 34, 38, 0.04)',
    [ThemeVariableType.DatabaseRelationIconBackgroundColor]: '#f4f4f6',
    [ThemeVariableType.DatabaseRelationIconBackgroundHoverColor]: '#e0e1e5',
    [ThemeVariableType.CalendarEventDefaultColor]: '#3e63dd',
    [ThemeVariableType.TimeTrackerChartBarColor]: '#3e63dd',
    [ThemeVariableType.PaletteColors]: GraphitePaletteColors,
    // szarosci palety Grafitu maja C ok. 0,007 - minimum nasycenia napisu plakietki (Pastelowe 0,02, Kolorowy tekst 0,06)
    // barwiloby je na niebiesko przy neutralnym tle; ponizej progu napis jest neutralny jak atrament palety
    [ThemeVariableType.LightBadgeNeutralChromaThreshold]: 0.012,
  }],
  // Lavenda = baza (LightModernThemeVariables) - bez nadpisan
  [LightModernPaletteVariantType.Lavender, {}],
])
